// Import console filters FIRST to suppress warnings from all imports
import './utils/suppressConsoleWarnings'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { updateTheme } from 'amo-styling-library'
import { ThemeProvider } from '@mui/material/styles'
import { getTheme } from 'amo-styling-library'
import App from './App.tsx'
import { ldhTheme } from './theme/ldhTheme'
import './index.css'

// Apply LDH Trans custom theme
updateTheme(ldhTheme)

createRoot(document.getElementById('root')!).render(
  <ThemeProvider theme={getTheme()}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ThemeProvider>
)
